import { ERA_LOOKS } from '@continuum/show-core';
import type { TaskDef } from '@continuum/show-core';
import { Screen } from '../../ui/Shell.js';
import { Eyebrow, Lede, Spacer } from '../../ui/atoms.js';
import { TaskQueue } from '../../ui/TaskQueue.js';
import type { QueueRow } from '../../ui/TaskQueue.js';
import type { ScreenCopy } from '../../ui/screenText.js';

/**
 * Era 4 — Underground. Ordinary games like every other stop: a line about where we are, lanterns swaying
 * over the sand, and the list. (Until 2026-10-24 it had a repair kit to TRADE for, left from the garden
 * vote's barter rule — nothing repairs damage, and the games are the charge.)
 */
export function Underground({
  rows,
  s,
  title,
  onOpen,
}: {
  rows: QueueRow[];
  s: ScreenCopy;
  title: (def: TaskDef) => string;
  onOpen: (row: QueueRow) => void;
}) {
  const look = ERA_LOOKS[4];
  return (
    <Screen style={{ background: 'linear-gradient(180deg,#140d05,#1d1308)', color: '#f6e7cf', padding: 24 }}>
      <Eyebrow color={look.acc}>{s.era4Eyebrow}</Eyebrow>
      <h1 style={{ margin: '12px 0 6px', fontSize: 24, fontWeight: 700, letterSpacing: 2 }}>{s.era4Title}</h1>
      <Lede color="#c9ad86">{s.era4Lede}</Lede>

      <svg viewBox="0 0 200 64" style={{ display: 'block', width: '100%', maxWidth: 320, margin: '18px auto 0' }} aria-hidden="true">
        <path d="M0 58 Q50 50 100 56 T200 54" stroke="rgba(224,138,60,.5)" strokeWidth="1.4" fill="none" />
        {[40, 100, 160].map((x, i) => (
          <g key={x} style={{ transformOrigin: `${x}px 4px`, animation: `ccSway ${4.5 + i * 0.8}s ease-in-out ${i * 0.5}s infinite` }}>
            <path d={`M${x} 4 V${22 + i * 4}`} stroke="rgba(246,231,207,.35)" strokeWidth="0.8" />
            <rect x={x - 4} y={22 + i * 4} width="8" height="11" rx="2" fill={look.acc} opacity=".85" />
            <circle cx={x} cy={27.5 + i * 4} r="7" fill={look.acc} opacity=".12" />
          </g>
        ))}
      </svg>

      <TaskQueue rows={rows} look={look} s={s} title={title} onOpen={onOpen} />
      <Spacer min={12} />
    </Screen>
  );
}
